// @ts-nocheck
import { useEffect, useRef } from 'react';
import { getUserTypesById, createUserType, updateUserType } from 'services/settings/userType';
import { getUserAccountsAPI } from 'services/settings/userAccount';
import HttpCodeMessage from 'shared_components/message_http_status';
import { showMessage } from 'services/settings/message';
import Message from 'shared_components/message';
import validationMessage from 'global_config/error_messages';
import { toUpper } from 'lodash';

function useFormDrawerHook(id, initialModules, onSuccess, visible) {
  const formRef = useRef();

  useEffect(() => {
    async function getData() {
      const response =  await getUserTypesById(id)
      const userTypeDetail = response.data[0];

      if(response.status === 200 && userTypeDetail) {
        const moduleValues = getModuleValues(userTypeDetail.modules);

        const fieldValues = {
          userType: userTypeDetail.userType,
          typeDescription: userTypeDetail.typeDescription,
          active: userTypeDetail.active ,
          ...moduleValues,
        }
        formRef.current.setFieldsValue(fieldValues);
      }
    }

    if(id && visible) {
      getData();
    }

  }, [id, visible]);

  function getModuleValues(modules) {
    const moduleValues = {};

    if(modules && Array.isArray(modules)) {
      modules.forEach(module => {
        const { create, edit, print, view, moduleName } = module;

        const viewChecked = view === 'TRUE';
        const createChecked = create === 'TRUE';
        const editChecked = edit === 'TRUE';
        const printChecked = print === 'TRUE';

        moduleValues[`${moduleName}-view`] = viewChecked;
        moduleValues[`${moduleName}-create`] = createChecked;
        moduleValues[`${moduleName}-edit`] = editChecked;
        moduleValues[`${moduleName}-print`] = printChecked;

        // Set main module checkbox if ANY permission is TRUE
        moduleValues[`${moduleName}-module`] = viewChecked || createChecked || editChecked || printChecked;
      });
    }

    // Force DASHBOARD to true
    moduleValues['DASHBOARD-view'] = true;
    moduleValues['DASHBOARD-create'] = true;
    moduleValues['DASHBOARD-edit'] = true;
    moduleValues['DASHBOARD-print'] = true;
    moduleValues['DASHBOARD-module'] = true;

    return moduleValues;
  }

  function getActionValue(field) {
    return field ? 'TRUE' : 'FALSE';
  }

  async function callCreateUserType(payload) {
    const response = await createUserType(payload);

    if(response.status === 201) {
      showMessage('M0002', {
        onClose: () => {
          if(onSuccess) onSuccess();
        }
      });
    }
  }

  async function callUpdateUserType(payload) {
    const response = await updateUserType(payload);

    if(response.status === 200) {
      showMessage('M0003', {
        onClose: () => {
          if(onSuccess) onSuccess();
        }
      });
    }
  }

	function onSubmit(fieldValues) {
    const { userType, typeDescription } = fieldValues;

    const modules = initialModules.map(initModule => {
      const isDashboard = initModule.moduleName === 'DASHBOARD';
      return {
        moduleID: initModule.moduleID,
        moduleName: initModule.moduleName,
        view: getActionValue(isDashboard ? true : fieldValues[`${initModule.moduleName}-view`]),
        create: getActionValue(isDashboard ? true : fieldValues[`${initModule.moduleName}-create`]),
        edit: getActionValue(isDashboard ? true : fieldValues[`${initModule.moduleName}-edit`]),
        print: getActionValue(isDashboard ? true : fieldValues[`${initModule.moduleName}-print`]),
      }
    });

    const payload = {
      userType: toUpper(userType),
      typeDescription: toUpper(typeDescription),
      active: fieldValues.active ? 1 : 0,
      modules
    };

    if(id && payload.active === 0) {
      // Check if there are active users assigned to this User Type
      getUserAccountsAPI().then(response => {
        if(response.status === 200 && response.data) {
          const activeUsers = response.data.filter(user => user.userTypeID === id && user.active === 1);
          if(activeUsers.length > 0) {
            Message.info(validationMessage.userTypeInUse);
            return;
          }
          callUpdateUserType({ userTypeID: id, ...payload });
        } else {
          callUpdateUserType({ userTypeID: id, ...payload });
        }
      }).catch(() => {
        callUpdateUserType({ userTypeID: id, ...payload });
      });
    } else if(id){
      callUpdateUserType({ userTypeID: id, ...payload })
    }else{
      callCreateUserType(payload);
    }
	}

  return { onSubmit, formRef };
}

export default useFormDrawerHook;